export const plastic = [
    {
      "a": 13,
      "b": 0,
      "c": [
        236,
        237,
        237
      ],
      "id": "H01",
      "t": "White",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        240,
        232,
        185
      ],
      "id": "H02",
      "t": "Cream",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        240,
        185,
        1
      ],
      "id": "H03",
      "t": "Yellow",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        230,
        79,
        39
      ],
      "id": "H04",
      "t": "Orange",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        182,
        49,
        54
      ],
      "id": "H05",
      "t": "Red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        225,
        136,
        159
      ],
      "id": "H06",
      "t": "Pink",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        105,
        74,
        130
      ],
      "id": "H07",
      "t": "Purple",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        44,
        70,
        144
      ],
      "id": "H08",
      "t": "Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        48,
        92,
        176
      ],
      "id": "H09",
      "t": "Light Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        37,
        104,
        71
      ],
      "id": "H10",
      "t": "Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        73,
        174,
        137
      ],
      "id": "H11",
      "t": "Light green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        83,
        65,
        55
      ],
      "id": "H12",
      "t": "Brown",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        192,
        36,
        53
      ],
      "id": "H13",
      "t": "Translucent Red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        252,
        204,
        60
      ],
      "id": "H14",
      "t": "Translucent Yellow",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        4,
        174,
        230
      ],
      "id": "H15",
      "t": "Translucent Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        55,
        184,
        118
      ],
      "id": "H16",
      "t": "Translucent Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        131,
        136,
        138
      ],
      "id": "H17",
      "t": "Grey",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        46,
        47,
        49
      ],
      "id": "H18",
      "t": "Black",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        216,
        210,
        206
      ],
      "id": "H19",
      "t": "Clear",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        127,
        51,
        42
      ],
      "id": "H20",
      "t": "Reddish Brown",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        165,
        105,
        63
      ],
      "id": "H21",
      "t": "Light Brown",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        165,
        45,
        54
      ],
      "id": "H22",
      "t": "Dark Red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        104,
        62,
        154
      ],
      "id": "H24",
      "t": "Translucent Purple",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        135,
        89,
        61
      ],
      "id": "H25",
      "t": "Translucent Brown",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        222,
        155,
        144
      ],
      "id": "H26",
      "t": "Flesh",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        222,
        180,
        139
      ],
      "id": "H27",
      "t": "Beige",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        54,
        63,
        56
      ],
      "id": "H28",
      "t": "Dark Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        185,
        57,
        94
      ],
      "id": "H29",
      "t": "Claret",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        89,
        47,
        56
      ],
      "id": "H30",
      "t": "Burgundy",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        103,
        151,
        174
      ],
      "id": "H31",
      "t": "Turquoise",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        32,
        141
      ],
      "id": "H32",
      "t": "Neon fuchsia",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        57,
        86
      ],
      "id": "H33",
      "t": "Cerise",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        229,
        239,
        19
      ],
      "id": "H34",
      "t": "Neon Yellow",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        40,
        51
      ],
      "id": "H35",
      "t": "Neon Red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        35,
        83,
        176
      ],
      "id": "H36",
      "t": "Neon Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        6,
        183,
        60
      ],
      "id": "H37",
      "t": "Neon Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        253,
        134,
        0
      ],
      "id": "H38",
      "t": "Neon Orange",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        241,
        242,
        28
      ],
      "id": "H39",
      "t": "Fluorescent Yellow",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        254,
        99,
        11
      ],
      "id": "H40",
      "t": "Fluorescent Orange",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        38,
        89,
        178
      ],
      "id": "H41",
      "t": "Fluorescent Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        12,
        189,
        81
      ],
      "id": "H42",
      "t": "Fluorescent Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        240,
        234,
        55
      ],
      "id": "H43",
      "t": "Pastel Yellow",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        238,
        105,
        114
      ],
      "id": "H44",
      "t": "Pastel Red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        136,
        109,
        185
      ],
      "id": "H45",
      "t": "Pastel Purple",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        98,
        158,
        215
      ],
      "id": "H46",
      "t": "Pastel Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        131,
        203,
        112
      ],
      "id": "H47",
      "t": "Pastel Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        207,
        112,
        183
      ],
      "id": "H48",
      "t": "Pastel Pink",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        73,
        152,
        188
      ],
      "id": "H49",
      "t": "Azure",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        254,
        175,
        61
      ],
      "id": "H60",
      "t": "Teddybear Brown",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        189,
        22,
        75
      ],
      "id": "H70",
      "t": "Light Gray",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        80,
        96,
        103
      ],
      "id": "H71",
      "t": "Dark Gray",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        245,
        131,
        174
      ],
      "id": "H72",
      "t": "Translucent Pink",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        143,
        219,
        239
      ],
      "id": "H73",
      "t": "Translucent Aqua",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        99,
        98,
        182
      ],
      "id": "H74",
      "t": "Translucent Lilac",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        203,
        142,
        97
      ],
      "id": "H75",
      "t": "Tan",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        145,
        90,
        57
      ],
      "id": "H76",
      "t": "Nougat",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        217,
        213,
        201
      ],
      "id": "H77",
      "t": "Cloudy White",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        211,
        180
      ],
      "id": "H78",
      "t": "Light Flesh",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        137,
        67
      ],
      "id": "H79",
      "t": "Apricot",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        156,
        40,
        100
      ],
      "id": "H82",
      "t": "Plum",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        72,
        159,
        189
      ],
      "id": "H83",
      "t": "Petrol Blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        121,
        141,
        72
      ],
      "id": "H84",
      "t": "Olive Green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        192,
        213,
        196
      ],
      "id": "H55",
      "t": "Glow in the dark green",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        233,
        187,
        173
      ],
      "id": "H56",
      "t": "Glow in the dark red",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        161,
        201,
        211
      ],
      "id": "H57",
      "t": "Glow in the dark blue",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        220,
        183,
        136
      ],
      "id": "H61",
      "t": "Gold",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        150,
        170,
        171
      ],
      "id": "H62",
      "t": "Silver",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        176,
        166,
        118
      ],
      "id": "H63",
      "t": "Bronze",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        200,
        201,
        195
      ],
      "id": "H64",
      "t": "Pearl",
      "dt": "Hama"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        255,
        255
      ],
      "id": "S01",
      "t": "White",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        163,
        139
      ],
      "id": "S02",
      "t": "Burning Sand",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        246,
        176,
        76
      ],
      "id": "S03",
      "t": "Tangerine",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        103,
        31
      ],
      "id": "S04",
      "t": "Orange",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        225,
        6,
        0
      ],
      "id": "S05",
      "t": "Tall Poppy",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        236,
        134,
        208
      ],
      "id": "S06",
      "t": "Raspberry Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        155,
        155,
        155
      ],
      "id": "S07",
      "t": "Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        36,
        222,
        91
      ],
      "id": "S08",
      "t": "Emerald",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        104,
        94
      ],
      "id": "S09",
      "t": "Dark Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        65,
        182,
        230
      ],
      "id": "S10",
      "t": "Baby Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        79,
        159,
        179
      ],
      "id": "S100",
      "t": "Lagoon",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        49,
        150,
        221
      ],
      "id": "S101",
      "t": "Electric Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        27,
        108,
        182
      ],
      "id": "S102",
      "t": "Pool Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        8,
        57,
        128
      ],
      "id": "S103",
      "t": "Caribbean Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        10,
        102,
        139
      ],
      "id": "S104",
      "t": "Deep Water",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        8,
        91,
        110
      ],
      "id": "S105",
      "t": "Petrol Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        78,
        120
      ],
      "id": "S106",
      "t": "Wedgwood Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        85,
        116
      ],
      "id": "S107",
      "t": "Pond Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        204,
        190,
        128
      ],
      "id": "S108",
      "t": "Seashell Beige",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        164,
        147,
        80
      ],
      "id": "S109",
      "t": "Beige",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        51,
        153
      ],
      "id": "S11",
      "t": "Dark Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        158,
        136,
        60
      ],
      "id": "S110",
      "t": "Beach Beige",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        118,
        108,
        43
      ],
      "id": "S111",
      "t": "Cafe Latte",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        121,
        95,
        38
      ],
      "id": "S112",
      "t": "Oaktree Brown",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        186,
        184,
        162
      ],
      "id": "S113",
      "t": "Khaki",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        114,
        140,
        84
      ],
      "id": "S114",
      "t": "Light Green Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        126,
        124,
        68
      ],
      "id": "S115",
      "t": "Mossy Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        100,
        105,
        46
      ],
      "id": "S116",
      "t": "Earth Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        78,
        88,
        44
      ],
      "id": "S117",
      "t": "Sage Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        74,
        94,
        45
      ],
      "id": "S118",
      "t": "Pinetree Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        113,
        196,
        182
      ],
      "id": "S119",
      "t": "Frosty Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        160,
        94,
        181
      ],
      "id": "S12",
      "t": "Pastel Lavender",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        102,
        204,
        153
      ],
      "id": "S120",
      "t": "Polar Mint",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        86,
        154,
        131
      ],
      "id": "S121",
      "t": "Celadon Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        20,
        194,
        91
      ],
      "id": "S122",
      "t": "Eucalyptus",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        24,
        168,
        24
      ],
      "id": "S123",
      "t": "Clover Field",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        4,
        85,
        46
      ],
      "id": "S124",
      "t": "Pool Table Felt",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        19,
        107,
        90
      ],
      "id": "S125",
      "t": "Snake Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        5,
        70,
        65
      ],
      "id": "S126",
      "t": "Dark Eucalyptus",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        217,
        182,
        214
      ],
      "id": "S127",
      "t": "Marshmallow Rose",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        173,
        98,
        164
      ],
      "id": "S128",
      "t": "Light Grape",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        230,
        140,
        163
      ],
      "id": "S129",
      "t": "Rosebud Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        0,
        0
      ],
      "id": "S13",
      "t": "Black",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        222,
        84,
        121
      ],
      "id": "S130",
      "t": "Fuschia",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        158,
        130,
        186
      ],
      "id": "S131",
      "t": "Candy Violet",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        232,
        65,
        107
      ],
      "id": "S132",
      "t": "Flamingo",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        183,
        56,
        143
      ],
      "id": "S133",
      "t": "Pink Plum",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        88,
        31,
        126
      ],
      "id": "S134",
      "t": "Amethyst",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        140,
        163,
        212
      ],
      "id": "S135",
      "t": "Moonlight Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        154,
        154,
        204
      ],
      "id": "S136",
      "t": "Summer Rain",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        89,
        129,
        193
      ],
      "id": "S137",
      "t": "Azure Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        65,
        102,
        176
      ],
      "id": "S138",
      "t": "Cornflower Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        71,
        95,
        171
      ],
      "id": "S139",
      "t": "Forget Me Not",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        250,
        224,
        83
      ],
      "id": "S14",
      "t": "Sandstorm",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        55,
        69,
        147
      ],
      "id": "S140",
      "t": "Indigo",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        61,
        86,
        165
      ],
      "id": "S141",
      "t": "Horizon Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        41,
        66,
        135
      ],
      "id": "S142",
      "t": "Cobalt",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        37,
        38,
        138
      ],
      "id": "S143",
      "t": "Royal Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        26,
        47,
        111
      ],
      "id": "S144",
      "t": "Marine",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        211,
        201,
        93
      ],
      "id": "S145",
      "t": "Pale Yellow Moss",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        81,
        9,
        24
      ],
      "id": "S146",
      "t": "Bloodrose Red",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        100,
        179,
        158
      ],
      "id": "S147",
      "t": "Spearmint",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        99,
        67,
        56
      ],
      "id": "S148",
      "t": "Mocha",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        237,
        211,
        158
      ],
      "id": "S149",
      "t": "Creme",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        122,
        62,
        44
      ],
      "id": "S15",
      "t": "Redwood",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        105,
        99,
        171
      ],
      "id": "S150",
      "t": "Iris Violet",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        43,
        63,
        31
      ],
      "id": "S151",
      "t": "Forest Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        151,
        145,
        197
      ],
      "id": "S152",
      "t": "Lilac",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        184,
        189,
        224
      ],
      "id": "S153",
      "t": "Pale Lilac",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        249,
        200,
        152
      ],
      "id": "S154",
      "t": "Sahara Sand",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        195,
        144,
        105
      ],
      "id": "S155",
      "t": "Sunkissed Tint",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        90,
        90,
        90
      ],
      "id": "S156",
      "t": "Steel Grey",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        60,
        60,
        60
      ],
      "id": "S157",
      "t": "Iron Grey",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        26,
        26,
        26
      ],
      "id": "S158",
      "t": "Pepper",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        139,
        139,
        139
      ],
      "id": "S159",
      "t": "Oslo Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        92,
        71,
        56
      ],
      "id": "S16",
      "t": "Brown",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        123,
        77,
        53
      ],
      "id": "S17",
      "t": "Light Brown",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        204,
        153,
        102
      ],
      "id": "S18",
      "t": "Sand",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        252,
        191,
        169
      ],
      "id": "S19",
      "t": "Bubble Gun",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        36,
        158,
        107
      ],
      "id": "S20",
      "t": "Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        135,
        216,
        57
      ],
      "id": "S21",
      "t": "Pastel Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        51,
        0,
        114
      ],
      "id": "S22",
      "t": "Purple",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        100,
        53,
        155
      ],
      "id": "S23",
      "t": "Royal Purple",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        20,
        123,
        209
      ],
      "id": "S24",
      "t": "True Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        52,
        179
      ],
      "id": "S25",
      "t": "Hot Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        219,
        33,
        82
      ],
      "id": "S26",
      "t": "Magenta",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        209,
        0
      ],
      "id": "S27",
      "t": "Yellow",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        234,
        184,
        228
      ],
      "id": "S28",
      "t": "Lily Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        246,
        235,
        97
      ],
      "id": "S29",
      "t": "Pastel Yellow",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        153,
        214,
        234
      ],
      "id": "S30",
      "t": "Shadow Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        158,
        229,
        176
      ],
      "id": "S31",
      "t": "Sea Mist",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        231,
        128
      ],
      "id": "S32",
      "t": "Beeswax",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        197,
        180,
        227
      ],
      "id": "S33",
      "t": "Maverick",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        186,
        12,
        47
      ],
      "id": "S34",
      "t": "Red",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        247,
        206,
        215
      ],
      "id": "S35",
      "t": "Mona Lisa",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        201,
        128,
        158
      ],
      "id": "S36",
      "t": "Old Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        113,
        216,
        191
      ],
      "id": "S37",
      "t": "Blue-Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        171,
        37,
        86
      ],
      "id": "S38",
      "t": "Burgundy",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        237,
        139,
        0
      ],
      "id": "S39",
      "t": "Yellow Orange",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        241,
        167,
        220
      ],
      "id": "S40",
      "t": "Carnation Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        154,
        85,
        22
      ],
      "id": "S41",
      "t": "Metallic Gold",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        125,
        124,
        121
      ],
      "id": "S42",
      "t": "Metallic Silver",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        118,
        119,
        119
      ],
      "id": "S43",
      "t": "Dark Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        170,
        220,
        235
      ],
      "id": "S44",
      "t": "Sky Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        178,
        169
      ],
      "id": "S45",
      "t": "Medium Turquoise",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        115,
        211,
        60
      ],
      "id": "S46",
      "t": "Bright Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        180,
        126,
        0
      ],
      "id": "S47",
      "t": "Marigold",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        199,
        44
      ],
      "id": "S48",
      "t": "Corn",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        114,
        25,
        95
      ],
      "id": "S49",
      "t": "Mulberry Wood",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        250,
        170,
        114
      ],
      "id": "S50",
      "t": "Mandy's Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        252,
        251,
        205
      ],
      "id": "S51",
      "t": "Spring Sun",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        242,
        240,
        161
      ],
      "id": "S52",
      "t": "Picasso",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        105,
        179,
        231
      ],
      "id": "S53",
      "t": "Turquoise",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        144,
        218
      ],
      "id": "S54",
      "t": "Light Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        173,
        220,
        145
      ],
      "id": "S55",
      "t": "Pistachio",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        106,
        19
      ],
      "id": "S56",
      "t": "Bright Carrot",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        164,
        73,
        61
      ],
      "id": "S57",
      "t": "Buccaneer",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        165,
        0,
        52
      ],
      "id": "S58",
      "t": "Paprika",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        74,
        31,
        135
      ],
      "id": "S59",
      "t": "Butterfly Bush",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        167,
        123,
        202
      ],
      "id": "S60",
      "t": "Lavender",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        206,
        220,
        0
      ],
      "id": "S61",
      "t": "Key Lime Pie",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        124,
        88
      ],
      "id": "S62",
      "t": "Green Tea",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        88,
        87,
        53
      ],
      "id": "S63",
      "t": "Metallic Copper",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        5,
        8,
        73
      ],
      "id": "S64",
      "t": "Black Rock",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        243,
        234,
        93
      ],
      "id": "S65",
      "t": "Canary",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        244,
        99,
        58
      ],
      "id": "S66",
      "t": "Blaze Orange",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        243,
        207,
        179
      ],
      "id": "S67",
      "t": "Vanilla",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        225,
        192,
        120
      ],
      "id": "S68",
      "t": "Tan",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        40,
        40,
        40
      ],
      "id": "S69",
      "t": "Mine Shaft",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        155,
        188,
        17
      ],
      "id": "S70",
      "t": "Dark Algae",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        133,
        34
      ],
      "id": "S71",
      "t": "Jade Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        89,
        213,
        216
      ],
      "id": "S72",
      "t": "Light Sea Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        72,
        169,
        197
      ],
      "id": "S73",
      "t": "Steel Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        174,
        214
      ],
      "id": "S74",
      "t": "Azure",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        133,
        173
      ],
      "id": "S75",
      "t": "Dark Steel Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        0,
        174,
        199
      ],
      "id": "S76",
      "t": "Sea Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        239,
        239,
        239
      ],
      "id": "S77",
      "t": "Ghost White",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        209,
        209,
        209
      ],
      "id": "S78",
      "t": "Ash Grey",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        187,
        188,
        188
      ],
      "id": "S79",
      "t": "Light Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        153,
        155,
        48
      ],
      "id": "S80",
      "t": "Dark Olive",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        205,
        178,
        119
      ],
      "id": "S81",
      "t": "Deer",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        181,
        129,
        80
      ],
      "id": "S82",
      "t": "Clay",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        184,
        97,
        37
      ],
      "id": "S83",
      "t": "Sienna",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        170,
        87,
        97
      ],
      "id": "S84",
      "t": "Deep Chestnut",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        92,
        19,
        27
      ],
      "id": "S85",
      "t": "Red Wine",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        234,
        170,
        0
      ],
      "id": "S86",
      "t": "Goldenrod",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        109,
        106
      ],
      "id": "S87",
      "t": "Coral Red",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        218,
        24,
        132
      ],
      "id": "S88",
      "t": "Dark Pink",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        77,
        77,
        77
      ],
      "id": "S89",
      "t": "Charcoal Gray",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        197,
        110
      ],
      "id": "S90",
      "t": "Pastel Orange",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        24,
        48,
        40
      ],
      "id": "S91",
      "t": "Brunswick Green",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        222,
        185,
        71
      ],
      "id": "S92",
      "t": "Dandelion",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        218,
        182,
        152
      ],
      "id": "S93",
      "t": "Pale Skin",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        244,
        169,
        153
      ],
      "id": "S94",
      "t": "Warm Blush",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        238,
        125,
        103
      ],
      "id": "S95",
      "t": "Salmon",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        240,
        134,
        97
      ],
      "id": "S96",
      "t": "Apricot",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        212,
        114,
        42
      ],
      "id": "S97",
      "t": "Papaya",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        100,
        172,
        223
      ],
      "id": "S98",
      "t": "Himalaya Blue",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        100,
        194,
        220
      ],
      "id": "S99",
      "t": "Waterfall",
      "dt": "ArtKal"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        207,
        219,
        171
      ],
      "id": "80-19075",
      "t": "Glow in the dark green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        254,
        194,
        196
      ],
      "id": "80-15203",
      "t": "Flamingo",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        204,
        183
      ],
      "id": "80-19098",
      "t": "Sand",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        118,
        204,
        136
      ],
      "id": "80-19053",
      "t": "Pastel green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        241,
        123,
        184
      ],
      "id": "80-19006",
      "t": "Bubblegum",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        252,
        193,
        220
      ],
      "id": "80-19079",
      "t": "Light pink",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        240,
        87,
        165
      ],
      "id": "80-19083",
      "t": "Pink",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        245,
        46,
        111
      ],
      "id": "80-19038",
      "t": "Magenta",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        177,
        39,
        102
      ],
      "id": "80-19088",
      "t": "Raspberry",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        148,
        32,
        55
      ],
      "id": "80-19096",
      "t": "Cranapple",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        226,
        46,
        26
      ],
      "id": "80-19005",
      "t": "Red",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        132,
        11,
        28
      ],
      "id": "80-15961",
      "t": "Cherry",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        101,
        84
      ],
      "id": "80-15204",
      "t": "Salmon",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        160,
        138
      ],
      "id": "80-19063",
      "t": "Blush",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        67,
        61
      ],
      "id": "80-19059",
      "t": "Hot coral",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        237,
        150,
        79
      ],
      "id": "80-15213",
      "t": "Apricot",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        195,
        206,
        93
      ],
      "id": "80-15214",
      "t": "Sherbet",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        103,
        96,
        24
      ],
      "id": "80-15220",
      "t": "Olive",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        229,
        49,
        52
      ],
      "id": "80-15211",
      "t": "Tomato",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        218,
        98,
        48
      ],
      "id": "80-15212",
      "t": "Spice",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        83,
        116,
        29
      ],
      "id": "80-15219",
      "t": "Fern",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        161,
        62,
        48
      ],
      "id": "80-19020",
      "t": "Rust",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        253,
        213,
        222
      ],
      "id": "80-19033",
      "t": "Peach",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        252,
        165,
        92
      ],
      "id": "80-19090",
      "t": "Butterscotch",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        247,
        135,
        39
      ],
      "id": "80-19004",
      "t": "Orange",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        239,
        140
      ],
      "id": "80-19056",
      "t": "Pastel yellow",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        244,
        224,
        62
      ],
      "id": "80-19003",
      "t": "Yellow",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        236,
        231,
        107
      ],
      "id": "80-19002",
      "t": "Creme",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        255,
        179,
        63
      ],
      "id": "80-19057",
      "t": "Cheddar",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        203,
        215,
        79
      ],
      "id": "80-19097",
      "t": "Prickly pear",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        115,
        195,
        70
      ],
      "id": "80-19061",
      "t": "Kiwi lime",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        23,
        49,
        116
      ],
      "id": "80-19008",
      "t": "Dark blue",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        34,
        107,
        185
      ],
      "id": "80-19009",
      "t": "Light blue",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        126,
        166,
        215
      ],
      "id": "80-19093",
      "t": "Blueberry creme",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        51,
        90,
        170
      ],
      "id": "80-19070",
      "t": "Periwinkle blue",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        155,
        148,
        203
      ],
      "id": "80-19054",
      "t": "Pastel lavender",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        193,
        189,
        223
      ],
      "id": "80-15182",
      "t": "Lavender",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        95,
        85,
        171
      ],
      "id": "80-19007",
      "t": "Purple",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        241,
        233,
        218
      ],
      "id": "80-15208",
      "t": "Toasted marshmallow",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        173,
        190,
        185
      ],
      "id": "80-15206",
      "t": "Pewter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        26,
        120,
        55
      ],
      "id": "80-15199",
      "t": "Shamrock",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        9,
        67,
        159
      ],
      "id": "80-15200",
      "t": "Cobalt",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        35,
        43,
        80
      ],
      "id": "80-15201",
      "t": "Midnight",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        190,
        235,
        238
      ],
      "id": "80-15202",
      "t": "Robin’s egg",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        246,
        211,
        177
      ],
      "id": "80-15205",
      "t": "Fawn",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        75,
        100,
        94
      ],
      "id": "80-15207",
      "t": "Charcoal",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        156,
        89,
        33
      ],
      "id": "80-19085",
      "t": "Gold metallic",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        90,
        102,
        103
      ],
      "id": "80-19092",
      "t": "Dark grey",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        120,
        79,
        61
      ],
      "id": "80-19012",
      "t": "Brown",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        157,
        167,
        167
      ],
      "id": "80-19017",
      "t": "Grey",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        189,
        204,
        207
      ],
      "id": "80-19019",
      "t": "Clear",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        194,
        114,
        45
      ],
      "id": "80-19021",
      "t": "Light brown",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        241,
        193,
        147
      ],
      "id": "80-19035",
      "t": "Tan",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        119,
        211,
        198
      ],
      "id": "80-19011",
      "t": "Light green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        4,
        161,
        159
      ],
      "id": "80-19091",
      "t": "Parrot green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        119,
        197,
        228
      ],
      "id": "80-19052",
      "t": "Pastel blue",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        159,
        227,
        238
      ],
      "id": "80-19058",
      "t": "Toothpaste",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        135,
        200,
        228
      ],
      "id": "80-15184",
      "t": "Clear blue",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        22,
        158,
        197
      ],
      "id": "80-19062",
      "t": "Turquoise",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        154,
        70,
        163
      ],
      "id": "80-19060",
      "t": "Plum",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        216,
        223,
        209
      ],
      "id": "80-15181",
      "t": "Light grey",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        28,
        28,
        28
      ],
      "id": "80-19018",
      "t": "Black",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        245,
        246,
        242
      ],
      "id": "80-19001",
      "t": "White",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        62,
        187,
        193
      ],
      "id": "80-15217",
      "t": "Lagoon",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        61,
        139,
        143
      ],
      "id": "80-15218",
      "t": "Teal",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        208,
        127,
        186
      ],
      "id": "80-15210",
      "t": "Orchid",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        170,
        179,
        184
      ],
      "id": "80-15215",
      "t": "Mist",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        95,
        167,
        179
      ],
      "id": "80-15216",
      "t": "Sky",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        90,
        188,
        76
      ],
      "id": "80-19080",
      "t": "Green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        20,
        102,
        50
      ],
      "id": "80-19010",
      "t": "Dark green",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        37,
        89,
        71
      ],
      "id": "80-15179",
      "t": "Evergreen",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        205,
        215,
        223
      ],
      "id": "80-15187",
      "t": "Clear glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        144,
        202,
        81
      ],
      "id": "80-15188",
      "t": "Kiwi glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        207,
        196,
        103
      ],
      "id": "80-15189",
      "t": "Yellow glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        247,
        84,
        132
      ],
      "id": "80-15191",
      "t": "Pink glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        239,
        241,
        242
      ],
      "id": "80-15192",
      "t": "White glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        45,
        55,
        58
      ],
      "id": "80-15193",
      "t": "Black glitter",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        179,
        201,
        171
      ],
      "id": "80-15173",
      "t": "Fairy dust",
      "dt": "Perler"
    },
    {
      "a": 13,
      "b": 0,
      "c": [
        168,
        181,
        175
      ],
      "id": "80-15105",
      "t": "Pearl silver",
      "dt": "Perler"
    }
  ]